// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 1270) return "static/chunks/1270-63a838daedae2f0a.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"82":"271b4c84748a4d31","3738":"61f17379f434d658","5757":"a072fa0482056d5a","8402":"450718381bcced3f","8708":"1e307a1262be1d04","9415":"4c557549816c6cfe"}[chunkId] + ".js";
};